import { Typography, Box } from '@coolblue-development/freddy';
import EmailTransferIcon from '../../../Icons/EmailTransferIcon';
import { EmailTransfer } from '../../../../../models/Email';

interface TransferredBannerProps {
  transferDetails: EmailTransfer;
}

const TransferredBanner = ({ transferDetails }: TransferredBannerProps): JSX.Element => (
  <Box sx={{ margin: '16px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <EmailTransferIcon />
      <Typography variant="h6" color="subtle" sx={{ fontWeight: 400 }}>
        From <strong>{transferDetails.fromQueue}</strong> by {transferDetails.byAgent}
      </Typography>
    </Box>
    {transferDetails.comment && (
      <Typography variant="body" color="subtle" sx={{ textAlign: 'center', maxWidth: '480px', fontStyle: 'italic' }}>
        &ldquo;{transferDetails.comment}&rdquo;
      </Typography>
    )}
  </Box>
);

export default TransferredBanner;
